(() => {
  if (window.cstmFooterCookieSettingsBound) return;
  window.cstmFooterCookieSettingsBound = true;

  document.addEventListener("click", (event) => {
    const button = event.target.closest?.("[data-cstm-footer-cookie-settings]");
    if (!button) return;

    if (typeof window.__ucCmp?.showSecondLayer !== "function") {
      console.warn("Usercentrics cookie settings are unavailable.");
      return;
    }

    window.__ucCmp.showSecondLayer();
  });
})();
